/**
 * This component must live at the root of any component exported as a federated module.
 * It contains the critical providers that enable federated modules to reach all the
 * needed context providers.
 */
import { EnvProvider } from '@zenbusiness/application-commons-env';

import Authenticated from '#client/App/Authenticated';
import ClickstreamWrapper from '#client/App/ClickstreamWrapper';
import Providers from '#client/App/Providers';
import ENV, { DEFAULT_SEGMENT, RELEASE_VERSION } from '#client/build-env';

export default function FederatedEntry({ children }) {
  return (
    <EnvProvider env={ENV}>
      <EnvProvider env={`${DEFAULT_SEGMENT}/env?v=${RELEASE_VERSION}`}>
        <Providers federated>
          <Authenticated optional>
            <ClickstreamWrapper>{children}</ClickstreamWrapper>
          </Authenticated>
        </Providers>
      </EnvProvider>
    </EnvProvider>
  );
}
